import { useEffect, useState } from 'react';
import { store } from '../../redux/oldStore';
import { ServerResponse } from '../../utils/Server';

interface IAdminLoginData {
  UtcNow?: string;
  IsStaff?: boolean;
}

/**
 * Replaces AdminLogin.aspx. Super-key links from Overseer/NHD open with ?x=…
 * and complete login via AdminLogin/Entry (server redirect) or SuperLogin JSON.
 */
const AdminLoginPage = () => {
  const [message, setMessage] = useState('Owner Login');
  const [clock, setClock] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const superKey = params.get('x');

    if (superKey) {
      setMessage('Signing in…');
      // Server entry preserves Tools.RedirectTo first-time-login behavior.
      window.location.replace(`../AdminLogin/Entry${window.location.search}`);
      return;
    }

    store.server
      .postApi<ServerResponse<IAdminLoginData>>('../AdminLogin/Data', {})
      .then((x) => {
        if (x.Success) {
          setClock(x.Value?.UtcNow || '');
          if (x.Value?.IsStaff) {
            setMessage('Already signed in as staff. Redirecting…');
            window.location.href = '../';
            return;
          }
        }
        setMessage(
          'Owner login requires a super-key link from Overseer or the NHD contest admin tools.'
        );
      })
      .catch(() => {
        setMessage(
          'Owner login requires a super-key link from Overseer or the NHD contest admin tools.'
        );
      });
  }, []);

  return (
    <div className="main-body-page grow" data-testid="admin-login-page">
      <div style={{ maxWidth: 800, margin: '2rem auto' }}>
        <h2>
          Owner Login{' '}
          {clock ? (
            <span className="label label-info" data-testid="admin-login-clock">
              {clock}
            </span>
          ) : null}
        </h2>
        <p data-testid="admin-login-message">{message}</p>
      </div>
    </div>
  );
};

export default AdminLoginPage;
